<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="2">
        <div class="text-subtitle-2" v-text="$t('Admin.sort')"></div>
        <v-select :items="sortItems" v-model="sortFilter" solo></v-select>
      </v-col>
      <v-col cols="12" sm="2">
        <div class="text-subtitle-2" v-text="$t('Admin.type')"></div>
        <v-select
          clearable
          :items="['Name','Id']"
          :placeholder="$t('Admin.enterType')"
          v-model="filterAttribute"
          solo
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6">
        <div class="text-subtitle-2" v-text="$t('Admin.filter')"></div>
        <v-text-field :placeholder="$t('Admin.enterFilter')" solo v-model="filter"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-center">
        <v-btn class="mb-5" tile outlined color="primary" @click="$emit('create')">
          <v-icon left>mdi-plus-circle</v-icon>
          {{$t('DataHome.create')}}
        </v-btn>
      </v-col>
    </v-row>
    <template v-if="loading">
      <v-row justify="center">
        <v-col>
          <div class="text-center mt-5">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col v-for="devType in deviceTypesArray" :key="devType.id" cols="12" sm="4">
          <v-hover v-slot:default="{ hover }">
            <v-flex>
              <v-card
                :id="devType.id"
                style="cursor: pointer;"
                :elevation="hover ? 10 : 2"
                class="mx-auto"
                max-width="344"
                @click="sendChoosenDeviceType($event)"
              >
                <v-container>
                  <p class="headline text-wrap ma-3">{{devType.name}}</p>
                  <v-list-item three-line>
                    <v-list-item-content>
                      <div class="subtitle-2 text-wrap mb-2 text-uppercase">{{devType.id}}</div>

                      <v-list-item-subtitle>{{devType.description}}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{$t('Admin.countusers')}}{{devType.users.length}}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{$t('Admin.countdevices')}}{{devType.devices.length}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-container>
              </v-card>
            </v-flex>
          </v-hover>
        </v-col>
      </v-row>
    </template>
    <v-alert type="warning" v-if="!loading && noDeviceType">{{$t('Admin.nodeviceTypes')}}</v-alert>
  </v-container>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  props: {
    source: String,
  },
  data: () => ({
    deviceTypes: [],
    noDeviceType: true,
    filterAttribute: undefined,
    filter: "",
    sortFilter: "",
    sortItems: [],
    loading: true,
  }),
  computed: {
    deviceTypesArray: function () {
      let array = this.deviceTypes;
      if (this.filterAttribute != undefined) {
        array = [];
        this.deviceTypes.forEach((net) => {
          if (
            net[
              this.filterAttribute.charAt(0).toLowerCase() +
                this.filterAttribute.slice(1)
            ]
              .toLowerCase()
              .startsWith(this.filter.toLowerCase())
          ) {
            array.push(net);
          }
        });
      }
      function compareWithParam(param) {
        return function compare(d1, d2) {
          let a = d1.name;
          let b = d2.name;
          if (param == "Id") {
            a = d1.id;
            b = d2.id;
          }
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        };
      }

      if (array != undefined) {
        switch (this.sortFilter) {
          default:
            return array.sort(compareWithParam(this.filterAttribute));

          case this.$t("Admin.ascending"):
            return array.sort(compareWithParam(this.filterAttribute));

          case this.$t("Admin.descending"):
            return array.sort(compareWithParam(this.filterAttribute)).reverse();
        }
      } else {
        return array;
      }
    },
  },

  methods: {
    sendChoosenDeviceType: function (event) {
      let index = this.deviceTypes.findIndex((e) => {
        return e.id == event.currentTarget.id;
      });
      this.$emit("choosendeviceType", this.deviceTypes[index]);
    },
  },
  beforeMount: function () {
    this.sortItems = [this.$t("Admin.ascending"), this.$t("Admin.descending")];
    this.sortFilter = this.sortItems[0];
    axios
      .get(process.env.VUE_APP_API_ADDR + "/api/deviceType", {
        headers: { Authorization: tokenStore.getToken() },
      })
      .then((res) => {
        if (res.data.deviceTypes.length == 0) {
          this.noDeviceType = true;
          this.loading = false;
        } else {
          this.noDeviceType = false;
          res.data.deviceTypes.forEach((devType) => {
            axios
              .get(
                process.env.VUE_APP_API_ADDR +
                  "/api/deviceType/" +
                  devType.id +
                  "/users",
                {
                  headers: { Authorization: tokenStore.getToken() },
                }
              )
              .then((res) => {
                if (res.data.success) {
                  devType.users = res.data.users;
                  axios
                    .get(
                      process.env.VUE_APP_API_ADDR +
                        "/api/deviceType/" +
                        devType.id +
                        "/devices",
                      {
                        headers: { Authorization: tokenStore.getToken() },
                      }
                    )
                    .then((res) => {
                      if (res.data.success) {
                        devType.devices = res.data.devices;
                        this.deviceTypes.push(devType);
                      }
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                }
              })
              .catch((err) => {
                console.log(err);
              });
          });
          this.loading = false;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>
